import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, eur } from "../lib/api";
import { Button } from "../components/ui/button";
import { FileText, Plus } from "lucide-react";

const STATUT_COLORS = {
  "Brouillon": "bg-slate-400", "Envoyé": "bg-sky-500", "Relance": "bg-amber-500",
  "Négociation": "bg-amber-600", "Accepté": "bg-emerald-600", "Refusé": "bg-red-500", "Archivé": "bg-slate-400",
};

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    api.get("/quotes").then((r) => setQuotes(r.data)).catch(() => {});
    if (params.get("new")) {
      navigate(`/devis/nouveau${params.get("site") ? `?site=${params.get("site")}` : ""}`);
      setParams({}, { replace: true });
    }
  }, [params, navigate, setParams]);

  return (
    <div className="space-y-5" data-testid="quotes-page">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Devis & Chiffrage</h1>
        <Button data-testid="new-quote-button" onClick={() => navigate("/devis/nouveau")} className="bg-amber-500 text-slate-900 font-bold hover:bg-amber-400 h-12">
          <Plus className="h-5 w-5 mr-1" /> Nouveau devis
        </Button>
      </div>
      <div className="space-y-2" data-testid="quotes-list">
        {quotes.map((q) => (
          <Link key={q.id} to={`/devis/${q.id}`} data-testid={`quote-row-${q.id}`}
            className="flex items-center gap-3 bg-card rounded-xl border-2 border-border hover:border-amber-500 p-4 transition-all">
            <FileText className="h-6 w-6 text-amber-600 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-bold text-sm truncate">{q.numero} — {q.objet || "Sans objet"}</div>
              <div className="text-xs text-muted-foreground">{q.client_nom || "—"} • {q.date} • {q.territoire}</div>
            </div>
            <div className="text-right">
              <div className="font-mono-num font-bold">{eur(q.total_ttc)}</div>
              <span className={`${STATUT_COLORS[q.statut] || "bg-slate-400"} text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase`}>{q.statut}</span>
            </div>
          </Link>
        ))}
        {quotes.length === 0 && <p className="text-sm text-muted-foreground" data-testid="quotes-empty">Aucun devis. Créez le premier.</p>}
      </div>
    </div>
  );
}
